module.exports = __webpack_public_path__ + "media/images/signatur-946d36087ef4f2c023fae4d5bb0a7e8a.png";